import React from 'react';

import type { PolicyId } from '../../content/legal/types';

import CookiePolicyContent from './CookiePolicyContent';
import DPDPComplianceContent from './DPDPComplianceContent';
import GDPRComplianceContent from './GDPRComplianceContent';
import PrivacyPolicyContent from './PrivacyPolicyContent';
import RefundCancellationContent from './RefundCancellationContent';
import TermsOfServiceContent from './TermsOfServiceContent';
import TrustCenterContent from './TrustCenterContent';

type LocalizedPolicyId = PolicyId;

const LOCALIZED_POLICY_COMPONENTS: Record<
  LocalizedPolicyId,
  React.ComponentType<{ onNavigate?: (view: string) => void }>
> = {
  privacy: PrivacyPolicyContent,
  terms: TermsOfServiceContent,
  cookie: CookiePolicyContent,
  refund: RefundCancellationContent,
  gdpr: GDPRComplianceContent,
  trust: TrustCenterContent,
  dpdp: DPDPComplianceContent,
};

export function hasLocalizedPolicyBody(_policyId: PolicyId): _policyId is LocalizedPolicyId {
  return true;
}

interface LocalizedPolicyBodyProps {
  policyId: LocalizedPolicyId;
  onNavigate?: (view: string) => void;
}

const LocalizedPolicyBody: React.FC<LocalizedPolicyBodyProps> = ({ policyId, onNavigate }) => {
  const Component = LOCALIZED_POLICY_COMPONENTS[policyId];
  return (
    <article className="policy-doc-card policy-doc-card--localized">
      <Component onNavigate={onNavigate} />
    </article>
  );
};

export default LocalizedPolicyBody;
